import React from 'react';

const BillList: React.FC = () => {
  return (
    <div>
      Bill List page
    </div>
  );
};

export default BillList;
